import { Documentzero__table_interface } from '@bludata/common-interfaces';

export const DefaultDocumentGridValue: Documentzero__table_interface = {
  campo_1: '',
  campo_2: '',
  campo_3: '',
  campo_4: null,
  codiceABarre: '',
  codiceDdt: '',
  codiceDocumento: '',
  codiceDoganale: '',
  codiceFiliale: '',
  codiceIva: '',
  codiceMovimento: '',
  codiceSpesaSts: '',
  codiceTipo: '',
  dataFine: null,
  dataInizio: null,
  descrizione: '',
  flag: null,
  id: 1,
  importo: null,
  importoIvato: null,
  iva: null,
  lotto: '',
  movimentoval: null,
  operatore: '',
  prezzo: null,
  prezzoIvato: null,
  quantita: null,
  riferimentoamministrazione: '',
  rigaDdt: '',
  sconto: '',
  scontoPercentuale: null,
  scontoValore: null,
  siglaDdt: '',
  siglaDocumento: '',
};
